import { Component } from "@angular/core";

@Component({
  selector: "indicator-loader",
  templateUrl: "./indicator-loader.component.html",
  styleUrls: ["./indicator-loader.component.scss"],
})
export class IndicatorLoaderComponent {}
